import * as React from 'react';
import * as CONST from '../../../helpers/const';
import 'core-js/fn/object/assign';

const ElementMessage = (props) => {
    var message = props.message;
    var status = props.status;
    if (message === null || message === "") { return null }
    if (status === CONST.ApiResult.Error) {
        if(message.indexOf("\\n") !== -1){
            return (
                <div className="col-xs-12">
                    <div className="alert alert-danger text-danger alert-dismissable">
                        <button type="button" className="close" data-dismiss="alert" aria-hidden="true" onClick={props.clearMessage.bind(this)}>×</button>                            
                            {message.split("\\n").map(function(place, i) {
                                return <p style={{margin:"0px"}} key={i}>{place}</p>
                            })}
                    </div>
                </div>
            );
        } else { 
            return (
                <div className="col-xs-12">
                    <div className="alert alert-danger text-danger alert-dismissable">
                        <button type="button" className="close" data-dismiss="alert" aria-hidden="true" onClick={props.clearMessage.bind(this)}>×</button>
                        {message}
                    </div>
                </div>
            );
        }
    } else {
        return (
            <div className="col-xs-12">
                <div className="alert alert-success text-success alert-dismissable">
                    <button type="button" className="close" data-dismiss="alert" aria-hidden="true" onClick={props.clearMessage.bind(this)}>×</button>
                    {message}
                </div>
            </div>
        );
    }
}
export default ElementMessage;


// WEBPACK FOOTER //
// ./components/common/elementmessage/index.jsx